import { z } from "zod";

export const toolingSetSchema = z.object({
  toolingSetId: z.string().min(1, "Tooling Set Id is required"),
  lowerTool: z.string().min(1, "Lower Tool is required"),
  upperTool: z.string().min(1, "Upper Tool is required"),
  shuttle: z.string().optional(),
  multiModule: z.string().optional(),
  flightTube: z.string().optional(),
  toolingType: z.string().optional(),
  machineType: z.string().trim().min(1, "Machine Type is required").max(30),
  orientation: z.string().optional(),
  singulation: z.string().optional(),
});

export type ToolingSetFormData = z.infer<typeof toolingSetSchema>;
